module.exports = __webpack_public_path__ + "img/ic_timesheets.656c4003.svg";